import { useEffect, useRef, useState } from "react"
import LineChart from "../../Components/highChart/new/NewLineChartGraficoElecciones"
import { listaColoresChart } from "../../Components/shared/colores";
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { getEcenariosFuente, getEcenariosGraficoSegundaVuelta, getEmpresasFuente, getEmpresasGraficoSegundaVuelta, getFuenteGrafico, getGrafico, getGraficoDataEspontanea, getGraficoPagina } from '../../services/service';
import highchartsSeriesLabel from 'highcharts/modules/series-label'; // Importar el módulo series-label
import Highcharts from 'highcharts'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Loading from "../../Components/shared/Loading/Loading";
import ts from "typescript";
import { get } from "http";

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 12,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 11 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition, fontSize: 14 };
    }
};


interface DataObject {
    Orden: string;
    Empresa: string;
    Candidatos: string;
    [key: string]: string; // Allow for dynamic keys for date columns
}


const GraficoEleccioneEceneario2vuelta = () => {
    const divRef = useRef(null);

    const [categories, setCategories] = useState([])
    const [data, setdata] = useState({ tituloProps: '', subtitleProps: '', selectValueProsp: [], formatDataStringData: '%', disableFilterProps: true, numDecimalProps: 0, pieTextProps: '', showPieTextInGraph: true, showLineTop: true, showSeries: true })
    const [arrayColores, setArrayColores] = useState(listaColoresChart);
    const [apiData, setApiData] = useState([]);
    const [stateLoading, setstateLoading] = useState(true)


    const [valueData, setValuesData] = useState<any[]>()
    const [selectedOptionsEmpresa, setSelectedOptionsEmpresa] = useState<any>();
    const [valueOptionsEmpresa, setvalueOptionsEmpresa] = useState<any>([]);

    const [selectedOptionsCandidatos, setSelectedOptionsCandidatos] = useState<any>();
    const [valueOptionsCandidatos, setvalueOptionsCandidatos] = useState<any>([]);
    const [dataMVP, setDataMVP] = useState<any>([]);

    highchartsSeriesLabel(Highcharts);


    const exportToPDF = () => {
        const element = document.getElementById('element-to-export');
        //@ts-ignore
        html2canvas(divRef.current).then(canvas => {
            const pdf = new jsPDF('p', 'mm', 'a4');
            pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 100);
            pdf.save('Elecciones_presidenciales_2025.pdf');
        });
    }
    const { tituloProps, subtitleProps, selectValueProsp, formatDataStringData, disableFilterProps,
        numDecimalProps,
        pieTextProps,
        showPieTextInGraph,
        showLineTop,
        showSeries } = data


    const handleCapture = () => {
        if (divRef.current) {
            html2canvas(divRef.current).then(canvas => {
                // Generar imagen base64
                const imgData = canvas.toDataURL('image/png');
                // Crear un enlace para descargar la imagen
                const link = document.createElement('a');
                link.download = 'Elecciones_presidenciales_2025.png';
                link.href = imgData;
                link.click();
            });
        }
    };
    const exportExcel = (params: any) => {
        //Creo un nuevo excel
        const wb = XLSX.utils.book_new();

        //Se setean los datos al formato para el excel
        const data = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));

        //Se crea una pagina por cada cada grafico con sus respectivos datos
        XLSX.utils.book_append_sheet(wb, data, 'Grafico');

        //Se descarga el excel
        XLSX.writeFile(wb, "Data " + "Grafico" + ".xlsx")
    }
    const setDataGraficoForExcel = (data: any) => {
        let arrayAux: any = [];
        console.log('datafor excel',data);
        
        const newvalue =data.map((item: any) => {
            let obj:any = {}

            item.data.forEach((itemData:any)=>{
                obj[itemData.propiedad]=itemData.valor
            })
            console.log('item',item.data);
            
            console.log('====================================');
            console.log('Grafico eleccienes', {empresa:item.empresa,escenario:item.escenario,candidato:item.candidatos,...obj});
            console.log('====================================');
            return {empresa:item.empresa,candidato:item.escenario,escenario:item.candidatos,...obj}


        })

        console.log('newvalue',newvalue);
        

       return newvalue
    }


    const onChangeSelectEmpresa = async (value: any) => {
        setSelectedOptionsEmpresa(value)
        console.log('emprena',value.value);
        setstateLoading(true)
        await getEcenariosGraficoSegundaVuelta(value.value).then((r: any) => {
            setstateLoading(false)
            setvalueOptionsCandidatos(r.data.data)
            
            console.log(r.data.data)
            if (r.data.data[2] !== undefined) {
                cargarGrafico( value,r.data.data[2])
                // console.log('r.data.data[3]',r.data.data[3]);
                // console.log('r.data.data[25]',r.data.data[25]);
                setSelectedOptionsCandidatos(r.data.data[2])
            } else {
                cargarGrafico(value, 0)
                setSelectedOptionsCandidatos(0)
            }
        })

    }

    const selectEscenario = async (value: any) => {

        setSelectedOptionsCandidatos(value)
        cargarGrafico(selectedOptionsEmpresa,value)
  
    }
    const  cargarGrafico =(empresa:any,value:any)=>{
        
        getGrafico( empresa.value,value.value).then((r: any) => {
            let labelsValue:any=[]
            let categoriasNoEliminar:any=[]
       
            setApiData(r.data.data)
            const newArrayValue= r.data.data.map((itemData:any)=>{
                 let data:any=[]
                 let labels:any=[]
        
             itemData.data.forEach((item:any,index:any)=>{
                     data.push(item.valor=='-'?null:item.valor)
                     labels.push(item.propiedad)
                })
                labelsValue = labels
                
                return {name:itemData.candidatos,data:data}
                
             })
            
             labelsValue.forEach((label: any,index: any) => {
                let sinValor = true;
                newArrayValue.forEach((item: any) => {
                    if(item.data[index]!=null) {
                        sinValor = false
                    } 

                })
                if (!sinValor) {
                    categoriasNoEliminar.push(index)
                }
                

             });

            
             const filteredLabels = labelsValue.filter((label: any, index: any) => categoriasNoEliminar.includes(index));
             const filteredData = newArrayValue.map((item: { name: any; data: any[]; },indexFilterdata: any) => ({
                 name: item.name,
                 data: item.data.filter((_: any, index: any) => categoriasNoEliminar.includes(index)),
                 color:listaColoresChart[indexFilterdata]
             }));



        setValuesData(filteredData)
        setCategories(filteredLabels)
            

        })
        
    }
    const cargarDats = async () => {
        setstateLoading(true)

        await getEmpresasGraficoSegundaVuelta().then((r: any) => {
            setstateLoading(false)
            setvalueOptionsEmpresa(r.data.data)
            onChangeSelectEmpresa(r.data.data[0])



        })

    }



    useEffect(() => {

        cargarDats()





    }, [])



    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className={`d-flex justify-content-center border-top-graph`} >
                        <div className="bg-body rounded chart-content mt-3">
                            {stateLoading ? <Loading loading={stateLoading} /> : null}

                            <div className="d-flex gap-2">
                                <div className="flex1">
                                    <Select
                                        className="react-select-container flex1"
                                        classNamePrefix="react-select "
                                        placeholder="Seleccionar..."
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        options={valueOptionsEmpresa}
                                        //@ts-ignore
                                        onChange={(e) => onChangeSelectEmpresa(e)}
                                        value={selectedOptionsEmpresa}
                                    />
                                </div>
                                <div className="flex1">
                                    <Select
                                        className="react-select-container flex1"
                                        classNamePrefix="react-select "
                                        placeholder="Seleccionar..."
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        options={valueOptionsCandidatos}
                                        onChange={(e) => selectEscenario(e)}
                                        value={selectedOptionsCandidatos}
                                    />
                                </div>



                            </div>

                            <div ref={divRef} className='mt-3 container-graphLine'>
                                <LineChart
                                    allData={valueData}
                                    title={'Elección presidencial 2025. Escenarios de 2da vuelta'}
                                    subtitle={''}
                                    numDecimalProps={numDecimalProps}
                                    pieTextProps={pieTextProps}
                                    showSeries={showSeries}
                                    formatDataStringData={formatDataStringData}
                                    showPieTextInGraph={showPieTextInGraph}
                                    labels={categories}
                                    colores={arrayColores}
                                    exportExcel={exportExcel}
                                    exportarImagen={handleCapture}
                                    activeButton={true}
                                />
                            </div>

                        </div>
                        {/* <ChartV5 /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GraficoEleccioneEceneario2vuelta